/* istanbul ignore next */
const ACTIONS = {
    GET_USER_INFO: 'GET_USER_INFO',
    GET_CONFIRMATION_PAGE_INFO: 'GET_CONFIRMATION_PAGE_INFO',
    GET_USER_INFO_SUCCESS: 'GET_USER_INFO_SUCCESS',
    USER_INFO_SERVICE_ERROR: 'USER_INFO_SERVICE_ERROR'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    getUserInfo() {
        return {
            type: ACTIONS.GET_USER_INFO
        };
    },

    getConfirmationPageInfo() {
        return {
            type: ACTIONS.GET_CONFIRMATION_PAGE_INFO
        };  
    },

    getUserInfoSuccess(userInfoData) {
        return {
            type: ACTIONS.GET_USER_INFO_SUCCESS,
            payload: {
                userInfoData
            }
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.USER_INFO_SERVICE_ERROR,
            payload: {
                errorKey
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
